import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=b7e8007c&scoped=true"
import script from "./Inbox.vue?vue&type=script&lang=js"
export * from "./Inbox.vue?vue&type=script&lang=js"
import style0 from "./Inbox.vue?vue&type=style&index=0&id=b7e8007c&prod&lang=css"
import style1 from "./Inbox.vue?vue&type=style&index=1&id=b7e8007c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e8007c",
  null
  
)

export default component.exports